'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';
import type { PageContext } from '../components/TripChat';

interface TripChatContextValue {
  pageContext: PageContext | undefined;
  setPageContext: (ctx: PageContext | undefined) => void;
}

const TripChatContext = createContext<TripChatContextValue>({
  pageContext: undefined,
  setPageContext: () => {},
});

export function TripChatContextProvider({ children }: { children: React.ReactNode }) {
  const [pageContext, setPageContextState] = useState<PageContext | undefined>();

  const setPageContext = useCallback((ctx: PageContext | undefined) => {
    setPageContextState(ctx);
  }, []);

  return (
    <TripChatContext.Provider value={{ pageContext, setPageContext }}>
      {children}
    </TripChatContext.Provider>
  );
}

export function useTripChatContext() {
  return useContext(TripChatContext);
}
